
import React, { useState } from "react";
import {
    Box,
    Typography,
    Toolbar,
    InputAdornment,
    IconButton,
    MenuItem,
    Select,
    FormControl,
    InputLabel,
    TextField
} from "@mui/material";
import {ContainerClasses} from '../../themes/containerClasses'
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import MenuIcon from "@mui/icons-material/Menu";
import AccountCircle from "@mui/icons-material/AccountCircle";
import {useTheme} from '@mui/material/styles';
import {LayoutFieldModel} from '../../models/models';
import {checkLayoutFieldRequirement} from '../../utils/fieldValidations';

export const SelectFieldComponent: React.FC<{
  layoutField: LayoutFieldModel,
  value: string,
  onChange: (value: string, layoutField: LayoutFieldModel) => void,
}> = ( {
  layoutField,
  value,
  onChange
}) => {

  const handleChange = (event: any) => {
    const value = event.target.value;

    onChange(value, layoutField);
  }

  const required = checkLayoutFieldRequirement(layoutField);

  const error = () => {
    if(required &&
       (!value || value == "\"\"")){
         return true
       }
    return false
  };

  const keys = Object.keys(layoutField.ReferencedField_sys.PicklistValues_sys)

  return (
      <FormControl
         fullWidth
         variant="filled"
         >
         <InputLabel
            required={required}
            error={error()}>
              {layoutField.ReferencedField_sys.Label_sys}
          </InputLabel>

         <Select
            value={value}
            onChange={(event) => handleChange(event)}
            size="small"
            disabled={layoutField.AccessSetting_sys === 'read'}
        >
           {keys.map((key) => {
             return (
             <MenuItem key={key} value={key}>{layoutField.ReferencedField_sys.PicklistValues_sys[key]}</MenuItem>
           )
           })}
         </Select>

      </FormControl>

    );

};
